import {
  RingLoader
} from "./GCJBVBMR.jsx";
import {
  cn
} from "./O62HZC57.jsx";

// src/Buttons/Button.tsx
import { A } from "@solidjs/router";
import { mergeProps, splitProps, Show } from "solid-js";
var Button = (originProps) => {
  const props = mergeProps(
    {
      type: "button",
      color: "primary",
      variant: "solid",
      rounded: "lg"
    },
    originProps
  );
  let lastTap = 0;
  const handleTouchEnd = (e) => {
    const currentTime = (/* @__PURE__ */ new Date()).getTime();
    const tapLength = currentTime - lastTap;
    if (tapLength < 300 && tapLength > 0) {
      props.onDblClick?.(e);
    }
    lastTap = currentTime;
  };
  const [, tagProps] = splitProps(props, ["type", "href", "form", "variant", "color", "rounded", "loading", "class", "onDblClick"]);
  const btnClass = () => cn(
    "relative flex h-fit px-5 py-2.5 text-base leading-5",
    { border: props.variant !== "text" },
    { "border-essential-colour": props.color === "primary" },
    {
      "text-blue border-link hover-allowed:hover:bg-blue/10": props.color === "link"
    },
    {
      "text-essential-colour hover-allowed:hover:bg-essential-colour/10": props.color === "primary"
    },
    {
      "border-danger hover-allowed:hover:border-danger/90 text-danger": props.variant === "outlined" && props.color === "warning"
    },
    {
      "text-white": props.variant === "solid" || props.variant === "outlined" && props.color === "white"
    },
    {
      "bg-essential-colour hover-allowed:hover:bg-essential-colour/90": props.variant === "solid" && props.color === "primary"
    },
    {
      "bg-danger hover-allowed:hover:bg-danger/90 border-danger": props.variant === "solid" && props.color === "warning"
    },
    { "bg-white hover-allowed:hover:bg-white/90": props.variant === "white" },
    { "rounded-md": props.rounded === "md" },
    { "rounded-lg": props.rounded === "lg" },
    { "rounded-full": props.rounded === "full" },
    { "opacity-50 cursor-not-allowed": props.disabled },
    { "flex h-[38px] items-center py-0": props.size === "sm" },
    {
      "flex h-[28px] items-center py-0 px-3 text-sm rounded-lg": props.size === "xs"
    },
    { "w-full justify-center": props.block },
    { "text-danger": props.variant === "text" && props.color === "warning" },
    props.class
  );
  const children = () => [
    <span
      class={cn("flex items-center justify-center gap-2", {
        invisible: props.loading
      })}
    >
      {props.children}
    </span>,
    <Show when={props.loading}>
      <RingLoader
      color={props.variant === "white" ? "#A126EC" : "white"}
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    />
    </Show>
  ];
  return <Show
    when={!props.href}
    fallback={<A href={props.href || ""} class={btnClass()} role="button" {...tagProps} onPointerUp={handleTouchEnd}>
          {children()}
        </A>}
  >
      <button class={btnClass()} type={props.type} form={props.form} {...tagProps} onPointerUp={handleTouchEnd}>
        {children()}
      </button>
    </Show>;
};

// src/Buttons/LinkButton.tsx
import { mergeProps as mergeProps2 } from "solid-js";
var LinkButton = Button;
var GrayLinkButton = (originProps) => {
  const props = mergeProps2(
    {
      class: "w-full border-text-level03 text-text-level01 hover-allowed:hover:border-essential-colour hover-allowed:hover:text-essential-colour py-2 px-5 text-sm leading-normal",
      variant: "outlined"
    },
    originProps
  );
  return <LinkButton {...props} />;
};
var WhiteLinkButton = (originProps) => {
  const props = mergeProps2(
    {
      class: "z-10 w-fit border-solid text-white border-white hover-allowed:hover:border-slate-100 hover-allowed:hover:bg-slate-100/10 hover-allowed:hover:text-slate-100 text-xs px-4 py-2.5",
      variant: "outlined",
      rounded: "md"
    },
    originProps
  );
  return <LinkButton {...props} />;
};

// src/Buttons/ModalButton.tsx
var ModalButton = (props) => <Button class="px-5 py-2 text-xs" variant="outlined" rounded="full" {...props}>
    {props.children}
  </Button>;

// src/Buttons/ToggleButton.tsx
import { createSignal } from "solid-js";
function ToggleButton(props) {
  const [isOn, setIsOn] = createSignal(props.initialState || false);
  const toggle = () => {
    setIsOn(!isOn());
    props.onToggle && props.onToggle(isOn());
  };
  return <div
    onClick={toggle}
    class={cn(
      "h-6 w-11 cursor-pointer rounded-full p-0.5 transition-colors duration-300",
      isOn() ? "bg-essential-colour" : "bg-auxiliary-text"
    )}
  >
      <div
    class={cn("size-5 rounded-full bg-white shadow-md transition-transform duration-300", isOn() ? "translate-x-5" : "translate-x-0")}
  />
    </div>;
}
var ToggleButton_default = ToggleButton;

export {
  Button,
  LinkButton,
  GrayLinkButton,
  WhiteLinkButton,
  ModalButton,
  ToggleButton_default
};
